import { AxiosResponse } from 'axios'

import { _axios } from 'hooks/axios'

const GET_QUESTIONNAIRE = `/onboarding/questionnaires`
const PUT_QUESTIONNAIRE = `/onboarding/questionnaires`

interface CreateOnboardingQuestionnaireRequest {
  weeklyWorkDays?: number // 0-7
  idealMonthlySalary?: number // 正の整数
  workEnvironmentPreference?: 1 | 2 | 3 // 1:solo, 2:team, 3:any
  shiftTimePreference?: 1 | 2 | 3 // 1:day, 2:night, 3:both
  commuteTimeMinutes?: number // 通勤時間（分）
  commuteMethods?: number // ビットフラグ [1:電車, 2:車, 4:バイク, 8:自転車, 16:徒歩]
  careerPositionPreference?: 1 | 2 // 1:leader, 2:support
  skillDevelopmentInterest?: boolean
  workDurationExpectation?: 1 | 2 // 1:long_term, 2:short_term
  companyDiscoverySource?: number
}

interface GetOnboardingQuestionnaireResponse {
  id: string
  securityId: string
  status: 0 | 1 | 2 // 0:未回答, 1:回答リクエスト, 2:回答済み
  weeklyWorkDays?: number
  idealMonthlySalary?: number
  workEnvironmentPreference?: 1 | 2 | 3
  shiftTimePreference?: 1 | 2 | 3
  commuteTimeMinutes?: number // 通勤時間（分）
  commuteMethods?: number // ビットフラグ [1:電車, 2:車, 4:バイク, 8:自転車, 16:徒歩]
  careerPositionPreference?: 1 | 2
  skillDevelopmentInterest?: boolean
  workDurationExpectation?: 1 | 2
  companyDiscoverySource?: 1 | 2 | 3 | 4 // 1:求人サイト, 2:新聞・雑誌, 3:知人紹介, 4:その他
}

export const onboardingApi = () => {
  const getQuestionnaire = async (): Promise<
    AxiosResponse<GetOnboardingQuestionnaireResponse>
  > => {
    return await _axios()
      .get(GET_QUESTIONNAIRE)
      .then((res) => {
        return res
      })
  }

  const updateQuestionnaire = async (
    data: CreateOnboardingQuestionnaireRequest,
  ): Promise<AxiosResponse<void>> => {
    return await _axios()
      .put(PUT_QUESTIONNAIRE, data)
      .then((res) => {
        return res
      })
  }

  return {
    getQuestionnaire,
    updateQuestionnaire,
  }
}
